<template>
    <div class="proposeList">
        <!-- <div class="header">
            <img src="@/assets/new/fan.png"  @click="goHome" alt="">
            <span>我的奖励</span>
        </div> -->
        <div class="shouview">
            <div
                class="shouitem"
                v-bind:class="{ sactive: revenue == 0 }"
                @click="changeRevenue(0)"
            >
                <img src="@/assets/c/shous.png" class="bg shous" alt="" />
                <img src="@/assets/c/shou.png" class="bg shou" alt="" />
                <div class="sitems">
                    {{ $t("new.quan") }}
                </div>
            </div>
            <div
                class="shouitem"
                v-bind:class="{ sactive: revenue == 1 }"
                @click="changeRevenue(1)"
            >
                <img src="@/assets/c/shous.png" class="bg shous" alt="" />
                <img src="@/assets/c/shou.png" class="bg shou" alt="" />
                <div class="sitems">
                    {{ $t("new.shou") }}
                </div>
            </div>
            <div
                class="shouitem"
                v-bind:class="{ sactive: revenue == 2 }"
                @click="changeRevenue(2)"
            >
                <img src="@/assets/c/shous.png" class="bg shous" alt="" />
                <img src="@/assets/c/shou.png" class="bg shou" alt="" />
                <div class="sitems">
                    {{ $t("new.zhichu") }}
                </div>
            </div>
        </div>
        <div class="leiview">
            <div class="leihead">
                <div class="one">{{ $t("new.shijian") }}</div>
                <div class="two" style="width: 40%">
                    {{ $t("new.leiname") }}
                </div>
                <div class="two" style="text-align: right">{{ $t("new.shuliang") }}</div>
                <!--                <div class="three">{{ $t('new.diming') }}</div>-->
            </div>
            <div class="leihead-content">
                <div
                    class="leihead leinav"
                    v-for="(log, key) in list"
                    :key="key"
                >
                    <div class="one time">
                        {{ log.created_at }}
                    </div>
                    <div class="two lname" style="width: 40%">
                        {{log.type_name}}
                    </div>
                    <div
                        class="two lname"
                        style="text-align: right"
                        :style="log.value > 0 ? 'color: #26E7FE' : ''"
                    >
                        {{ log.value > 0 ? `+${log.value}` : `${log.value}`  }}
                    </div>
                    <!--                <div class="three time">SD484***484</div>-->
                </div>

                <!--            <div class="leihead leinav">-->
                <!--                <div class="one time">-->
                <!--                    2024/09/19 14:58-->
                <!--                </div>-->
                <!--                <div class="two lname cai">-->
                <!--                    {{ $t('new.shou') }}-->
                <!--                </div>-->
                <!--                <div class="two lname cai">-500GMC</div>-->
                <!--&lt;!&ndash;                <div class="three time">SD484***484</div>&ndash;&gt;-->
                <!--            </div>-->
            </div>
        </div>
        <div class="fanview" @click="$router.go(-1)">
            <img src="@/assets/c/fan.png" class="bg" alt="" />
        </div>
    </div>
</template>

<script>
import { ajaxData } from "@/api/ajax";

export default {
    data() {
        return {
            revenue: 0,
            list: [],

        };
    },
    created() {
        let vm = this;
        vm.getData();
    },
    methods: {
        changeRevenue(revenue) {
            let vm = this;
            vm.revenue = revenue;
            this.list = [];
            vm.getData();
        },
        async getData() {
            let vm = this;
            // ajaxData("/user/log", {
            //     revenue: vm.revenue,
            // }).then((response) => {
            //     vm.list = response.data.list.list;
            //     console.log(response);
            // });
            let res = await ajaxData("/user/log/bouns", {
                type: this.revenue,
                field: "gmc_balance",
            });
            if (res.code == 0) {
                this.list.push(...res.data?.log);
            }
        },
        goHome() {
            this.$router.go(-1);
        },
    },
};
</script>


<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}

.proposeList {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    .shouview {
        position: relative;
        display: flex;
        flex-direction: row;
        padding: 30px 15px 20px;
        justify-content: space-between;
        .shouitem {
            width: 100px;
            height: 36px;
            position: relative;
            .shous {
                display: none;
            }
            .shou {
                display: inline-block;
            }
            .sitems {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 14px;
                color: #999999;
            }
        }
        .sactive {
            .sitems {
                color: #111111;
            }
            .shou {
                display: none;
            }
            .shous {
                display: inline-block;
            }
        }
    }
    .leiview {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        height: calc(100vh - 86px);
        box-sizing: border-box;
        .leihead-content {
            height: (100vh - 106px);
            overflow: scroll;
        }
        .leihead {
            display: flex;
            flex-direction: row;
            font-weight: 500;
            font-size: 12px;
            color: #111111;
        }
        .one {
            width: 32%;
        }
        .two {
            width: 20%;
            text-align: center;
        }
        .three {
            //width: 30%;
            text-align: right;
        }
        .leinav {
            border-bottom: 0.5px solid #eee;
            padding: 15px 0;
        }
        .time {
            font-weight: 500;
            font-size: 12px;
            color: #666666;
        }
        .lname {
            font-weight: 500;
            font-size: 12px;
            color: #333333;
        }
        .cai {
            color: #04b9cf;
        }
    }
    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding: 6px;
        box-sizing: border-box;
        background: rgba(52, 56, 75, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 55px;
            height: 55px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .mhead {
        // position: relative;
        // top: 50px;
    }
}
</style>
